
import { Options, prop, Vue } from "vue-class-component";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import HistoryChat from "./components/history-chat.vue";
import ChatBoxMessage from "./components/chat-box-message.vue";
import { TicketDetail, TicketAction } from "@/domain/entities/PusatResolusiV2";
import FollowReport from "../components/follow-report.vue";
import { PusatResolusiV2Mapper } from "@/data/persistences/mappers/PusatResolusiV2Mapper";
import ReviewFeedback from "./components/review-feedback.vue";
import { GetTicketActionRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { getHubData } from "@/app/infrastructures/misc/Cookies";

class Props {
  data = prop<TicketDetail>({
    required: true
  });
  detailId = prop<number>({
    required: true
  });
  websocket = prop<WebSocket>({
    required: true
  });
  action = prop<TicketAction>({
    required: true
  });
}

@Options({
  emits: ["getDetail"],
  components: {
    HistoryChat,
    ChatBoxMessage,
    FollowReport,
    ReviewFeedback
  },
  watch: {
    action: {
      handler(val: TicketAction) {
        this.ticketAction = val;
      }
    },
    websocket: {
      handler(ws: WebSocket) {
        ws.addEventListener("message", async (event) => {
          const mapper = new PusatResolusiV2Mapper();
          const conversation = mapper.convertHistoryChatResponseFromWebsocket(
            event.data
          )[0];
          console.log(conversation, "conversation");

          if (!conversation.type) {
            this.ticketAction = new TicketAction({
              isOpenMultipleTab: conversation.isOpenMultipleTab,
              isAssignedToOther: conversation.isAssignedToOther,
              assignedUsername: conversation.assignedUsername,
              action: conversation.action
            });
            this.isLoadingAction = false;
          }
        });
      }
    }
  }
})
export default class HistorySection extends Vue.with(Props) {
  ticketAction = new TicketAction();
  get isLoadingAction() {
    return PusatResolusiV2Controller.loadingAction;
  }

  get isShowChat() {
    return this.ticketAction.action.includes("chat");
  }
  get isShowFollow() {
    return this.ticketAction.action.includes("follow");
  }
  get isShowReviewFeedback() {
    return (
      this.ticketAction.action.includes("review_feedback") ||
      this.data.ticket.reviewType
    );
  }

  get message(): string {
    return PusatResolusiV2Controller.chatMessage;
  }

  set message(val: string) {
    PusatResolusiV2Controller.setChatMessage(val);
  }

  get caseNumber() {
    return this.data.ticket.caseNumber.toString();
  }

  async getTicketAction() {
    try {
      PusatResolusiV2Controller.setLoadingAction(true);
      this.ticketAction = await PusatResolusiV2Controller.getTicketAction({
        id: Number(this.$route.params.id as string),
        params: new GetTicketActionRequest({
          hubId: getHubData()?.hubId || "0"
        })
      });

      this.$emit("updateAction", this.ticketAction);
    } catch (err) {
      // implement error
    } finally {
      PusatResolusiV2Controller.setLoadingAction(false);
    }
  }

  onSuccessReview() {
    this.$emit("getDetail");
  }
}
